/**
 * Created by rak on 1/15/2016.
 */
'use strict';
angular.module('trackReporting', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'restangular', 'ui.router', 'pascalprecht.translate', 'jqwidgets', 'ab-base64', 'ui.bootstrap', 'LocalStorageModule']).config(function ($stateProvider) {
  $stateProvider
    .state('reports', {
      parent: 'betotrack',
      url: '/reports',
      abstract: true,
      ncyBreadcrumb: {
        skip: true
      }
    }).state('reports.vehicleDetail', {
      url: '/vehicle.detail?reportName&vehicleId&dateFrom&dateTo&hasCustomDateRange',
      views: {
        'content@app': {
          controller: 'RepoVehicleDetailCtrl',
          templateUrl: 'components/track/reports/vehicleDetailReport.tpl.html'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Vehicle Details';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      },
      ncyBreadcrumb: {
        label: '{{breadCrumbLabel}}'
      }
    })/*.state('reports.groupDetail', {
      url: '/group.detail?reportName&groupId&dateFrom&dateTo',
      views: {
        'content@app': {
          controller: 'RepoGroupDetailCtrl',
          templateUrl: 'components/track/reports/groupDetailReport.tpl.html'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Group Detail';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      },
      ncyBreadcrumb: {
        label: '{{breadCrumbLabel}}'
      }
    })*/
    .state('reports.groupSummary', {
      url: '/group.summary?reportName&groupId&dateFrom&dateTo',
      views: {
        'content@app': {
          controller: 'RepoGroupSummaryCtrl',
          templateUrl: 'components/track/reports/groupSummary.tpl.html'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Group Summary';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      },
      ncyBreadcrumb: {
        label: '{{breadCrumbLabel}}'
      }
    })
    .state('reports.performance', {
      url: '/performance?reportName&vehicleId&dateFrom&dateTo',
      views: {
        'content@app': {
          controller: 'RepoPerformanceCtrl',
          templateUrl: 'components/track/reports/performance.tpl.html'
        }
      },
      resolve: {
        $title: function () {
          return 'BetoTrack', 'Performance';
        },
        $sibebar: ['AdmStatusService', function (AdmStatusService) {
          AdmStatusService.setSidebarVisible(true);
          return true;
        }]
      },
      ncyBreadcrumb: {
        label: '{{breadCrumbLabel}}'
      }
    });
});



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/betoTrackReports.js